import { BellIcon as PhosphorBellIcon } from "@phosphor-icons/react/dist/ssr/Bell";

import { createAppIcon } from "@/components/createAppIcon";

export const NotificationIcon = /* @__PURE__ */ createAppIcon(PhosphorBellIcon);
